import type { FeedsClient } from '@stream-io/feeds-client'

import { FetchResult, isFetchResultSuccessful } from '../../entities/FetchResult'
import { ValkTalkPost, ValkTalkPostFormData } from '../../entities/ValkTalkPost/ValkTalkPost'
import {
    patchValkTalkPostApiCall,
    postValkTalkPostApiCall,
    uploadValkTalkPostImagesApiCall,
} from '../../entities/ValkTalkPost/ValkTalkPostService'
import { TypedDispatch } from '../store'
import { setSavedPost } from '../valkTalkPosts/valkTalkPostsReducer'
import {
    setError,
    setIsSuccessful,
    setIsUpdating,
} from './valkTalkPostReducer'

// Valkplanner creates posts and uploads their images itself; edits go straight to Stream, which only allows authors
// to edit their own posts
const updateValkTalkPost = async (
    client: FeedsClient,
    postId: string,
    formData: ValkTalkPostFormData,
): Promise<FetchResult<ValkTalkPost, string>> => {
    const uploadResponse = await uploadValkTalkPostImagesApiCall(client, formData.images)

    if (! isFetchResultSuccessful(uploadResponse)) {
        return uploadResponse
    }

    return patchValkTalkPostApiCall(client, postId, formData, uploadResponse.data)
}

export const saveValkTalkPost = (
    client: FeedsClient,
    formData: ValkTalkPostFormData,
    postId?: string,
) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsUpdating(true))
    dispatch(setIsSuccessful(false))
    dispatch(setError(''))

    try {
        const response = postId
            ? await updateValkTalkPost(client, postId, formData)
            : await postValkTalkPostApiCall(formData)

        if (! isFetchResultSuccessful(response)) {
            dispatch(setError(response.error))

            return
        }

        dispatch(setSavedPost(response.data))
        dispatch(setIsSuccessful(true))
    } catch (error) {
        console.error('[saveValkTalkPost]', error)
    } finally {
        dispatch(setIsUpdating(false))
    }
}
